/**
 * Must be the first import in main.tsx: zod builds its JIT when schemas are *constructed*
 * (at @viko/protocol module load), probing `new Function` — a Trusted Types / CSP violation.
 * `jitless` skips the probe; parsing speed is irrelevant at our volumes.
 */
import { config } from 'zod'

config({ jitless: true })
